const EYU_BASE_URL = {
  DEFAULT_BASE_URL: 'https://sdkapi.eyuconnect.com',
  USER_BASE_URL: 'https://user.eyuconnect.com',
  PAY_BASE_URL: 'https://sdkpay.eyuconnect.com',
  LOG_BASE_URL: 'https://sdklog.eyuconnect.com',
  MANAGE_BASE_URL: 'https://sdkmanage.eyuconnect.com'
}
const IQT_BASE_URL = {
  DEFAULT_BASE_URL: 'https://sdkapi.iqtconnect.com',
  USER_BASE_URL: 'https://user.iqtconnect.com',
  PAY_BASE_URL: 'https://sdkpay.iqtconnect.com',
  LOG_BASE_URL: 'https://sdklog.iqtconnect.com',
  MANAGE_BASE_URL: 'https://sdkmanage.iqtconnect.com'
}
let PRO_BASE_URL = {}
const host = window.location.host
if (host.includes('eyuconnect')) {
  PRO_BASE_URL = EYU_BASE_URL
} else if (host.includes('iqtconnect')) {
  PRO_BASE_URL = IQT_BASE_URL
}

const DEV_BASE_URL = {
  DEFAULT_BASE_URL: 'http://119.91.71.194:8005',
  USER_BASE_URL: 'http://119.91.71.194:8003',
  PAY_BASE_URL: 'http://119.91.71.194:8004',
  LOG_BASE_URL: 'http://119.91.71.194:8006',
  MANAGE_BASE_URL: 'http://119.91.71.194:8002',
}

const base = process.env.NODE_ENV === 'production' ? PRO_BASE_URL : DEV_BASE_URL

export default base